/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramGeoControllerGetCapitalQueryResponse,
  TelegramGeoControllerGetCapitalPathParams,
} from '../../types/TelegramGeoControllerGetCapital.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramGeoGetCapital } from '../../methods/telegramGeoGetCapital.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramGeoGetCapitalQueryKey = (countryId: TelegramGeoControllerGetCapitalPathParams['countryId']) =>
  [{ url: '/api/telegram/geo/capital/:countryId', params: { countryId: countryId } }] as const;

export type TelegramGeoGetCapitalQueryKey = ReturnType<typeof telegramGeoGetCapitalQueryKey>;

export function telegramGeoGetCapitalQueryOptions(
  countryId: TelegramGeoControllerGetCapitalPathParams['countryId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramGeoGetCapitalQueryKey(countryId);
  return queryOptions<
    TelegramGeoControllerGetCapitalQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramGeoControllerGetCapitalQueryResponse,
    typeof queryKey
  >({
    enabled: !!countryId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramGeoGetCapital(countryId, config);
    },
  });
}

/**
 * {@link /api/telegram/geo/capital/:countryId}
 */
export function useTelegramGeoGetCapital<
  TData = TelegramGeoControllerGetCapitalQueryResponse,
  TQueryData = TelegramGeoControllerGetCapitalQueryResponse,
  TQueryKey extends QueryKey = TelegramGeoGetCapitalQueryKey,
>(
  countryId: TelegramGeoControllerGetCapitalPathParams['countryId'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramGeoControllerGetCapitalQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramGeoGetCapitalQueryKey(countryId);

  const query = useQuery(
    {
      ...telegramGeoGetCapitalQueryOptions(countryId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
